import { Box, Button, Chip, Container, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';
import { backend } from 'src/api';

export const HomeHero = () => {
  const [serverDown, setServerDown] = useState(false);

  useEffect(() => {
    backend.get("/actuator/health")
      .then(() => setServerDown(false))
      .catch(() => setServerDown(true));
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        pt: { xs: '120px', md: '160px' },
        pb: { xs: 8, md: 0 },
      }}
    >
      {/* Background gradient orbs */}
      <Box
        sx={{
          position: 'absolute',
          top: -200,
          right: -200,
          width: 600,
          height: 600,
          borderRadius: '50%',
          background: (theme) =>
            `radial-gradient(circle, ${alpha(theme.palette.primary.main, 0.12)} 0%, transparent 70%)`,
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -100,
          left: -200,
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: (theme) =>
            `radial-gradient(circle, ${alpha(theme.palette.info.main, 0.08)} 0%, transparent 70%)`,
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth="lg">
        <Stack
          alignItems="center"
          spacing={4}
          sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}
        >
          <Chip
            label="다양한 부동산 지표를 한 곳에서"
            size="small"
            variant="outlined"
            sx={{
              borderColor: 'primary.main',
              color: 'primary.main',
              fontWeight: 600,
              px: 1,
            }}
          />

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: 36, md: 56 },
              fontWeight: 800,
              lineHeight: 1.2,
              maxWidth: 800,
              letterSpacing: '-0.02em',
            }}
          >
            데이터로 읽는
            <br />
            <Box
              component="span"
              sx={{
                background: (theme) =>
                  `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.info.main})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              부동산 시장
            </Box>
          </Typography>

          <Typography
            color="text.secondary"
            sx={{
              fontSize: { xs: 16, md: 20 },
              maxWidth: 600,
              lineHeight: 1.7,
            }}
          >
            전국 흐름을 보고, 지역을 분석하고, 아파트를 선정하세요.
            <br />
            나만의 분석 노트에 기록하며 변화를 꾸준히 관찰하세요.
          </Typography>

          {/* 서버 점검 중 안내 */}
          {serverDown && (
            <Chip
              label="서버 점검 중입니다. 잠시 후 다시 시도해주세요."
              size="small"
              sx={{
                bgcolor: 'error.main',
                color: 'white',
                fontWeight: 600,
                fontSize: 13,
                px: 2,
                py: 0.5,
              }}
            />
          )}

          <Stack
            direction="row"
            spacing={2}
            sx={{ mt: 2 }}
          >
            <Button
              component={RouterLink}
              href={paths.dashboard.index}
              size="large"
              variant="contained"
              disabled={serverDown}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: 16,
                fontWeight: 700,
                borderRadius: 2,
                boxShadow: (theme) => serverDown ? 'none' : `0 8px 24px ${alpha(theme.palette.primary.main, 0.35)}`,
              }}
            >
              시작하기
            </Button>
            <Button
              color="inherit"
              href="#features"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                fontSize: 16,
                borderRadius: 2,
              }}
            >
              기능 둘러보기
            </Button>
          </Stack>
        </Stack>

        {/* Hero screenshot */}
        <Box
          sx={{
            mt: { xs: 6, md: 10 },
            position: 'relative',
            mx: 'auto',
            maxWidth: 1040,
          }}
        >
          <Box
            sx={{
              position: 'relative',
              boxShadow: 'none',
              '& img': {
                width: '100%',
                display: 'block',
              },
            }}
          >
            <img
              src="/assets/mains/prop-lake-hero-v3.png"
              alt="PropLake 데이터레이크 분석 화면"
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
